/** Returns true when the JWT `exp` claim is in the past (or the token cannot be parsed). */
export function isJwtExpired(token: string, clockSkewSeconds = 30): boolean {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return true;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64)) as { exp?: unknown };
    if (typeof payload.exp !== 'number') {
      return false;
    }

    return Date.now() >= (payload.exp - clockSkewSeconds) * 1000;
  } catch {
    return true;
  }
}
